import { CaseFormModel } from "./case-form.model";

export class CaseResponseModel  extends CaseFormModel {

    constructor(values?: Partial<CaseResponseModel>) {
        super(values);
        Object.assign(this, values);
    }

    opened_at: string = '';
    sys_updated_on: string = '';
    u_usan_form_a: string = '';
    u_usan_form_b: string = '';
    u_usan_form_c: string = '';
    u_usan_form_d: string = '';
    u_usan_form_e: string = '';
    u_usan_form_f: string = '';
    
    public static parseValues(json: any) {
        if(!json) {
            return new CaseResponseModel();
        }
        
        let caseFormModel = CaseFormModel.parseValues(json);
        const responseDetails = {
            opened_at: json.opened_at,
            sys_updated_on: json.sys_updated_on,
            u_usan_form_a: json.u_usan_form_a,
            u_usan_form_b: json.u_usan_form_b,
            u_usan_form_c: json.u_usan_form_c,
            u_usan_form_d: json.u_usan_form_d,
            u_usan_form_e: json.u_usan_form_e,
            u_usan_form_f: json.u_usan_form_f
        };

        Object.assign(responseDetails, caseFormModel);
        return new CaseResponseModel(responseDetails);
    }
}
